module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Solicitações'
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Gerenciador de Arquivos de Documentos Fiscais")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), (_vm.loading.show) ? _c('div', {
    staticClass: "overlay-loading"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e(), _vm._v(" "), (_vm.mostrarEmails) ? _c('div', {
    staticClass: "column all-centered prest-emails-container",
    on: {
      "click": function($event) {
        return _vm.toggleEmails(false)
      }
    }
  }, [_c('prestacao-simplificada-emails', {
    attrs: {
      "toggleEmails": _vm.toggleEmails
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "prest-main-container"
  }, [_c('div', {
    staticClass: "prest-header row-flex centered-between"
  }, [_vm._m(0), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large',
        placement: 'top'
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
    }],
    staticClass: "row-flex centered-start prest-header-emails",
    attrs: {
      "title": "<h5>Verifica log de e-mails enviados</h5>"
    },
    on: {
      "click": function($event) {
        return _vm.toggleEmails(true)
      }
    }
  }, [_vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column start-centered"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Status de Prestação de Contas "), (this.usuarioLogado.userType === 'FUNDACAO') ? _c('span', [_vm._v(" do Processo Simplificado")]) : _vm._e()])])]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "box-body row-flex centered-start prest-row-input"
  }, [_c('div', {
    staticClass: "prest-input-group"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large',
        placement: 'top'
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
    }],
    staticClass: "input-group",
    attrs: {
      "title": '<h5>Pesquise por nome, partes do nome, proposta ou número do projeto.<h5>'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa),
      expression: "pesquisa"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa...",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisa = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" ")])])])])]) : _vm._e(), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": true,
      "items": _vm.table.items,
      "striped": "",
      "hover": "",
      "fields": _vm.table.fields,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "filter": _vm.table.filter,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Faça uma pesquisa acima",
      "table-layout:": "",
      "fixed": ""
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "data_atualizacao",
      fn: function(row) {
        return [(row.item.data_atualizacao) ? _c('div', [_vm._v("\n                  " + _vm._s(_vm._f("moment")(row.item.data_atualizacao, 'DD/MM/YYYY HH:mm:ss')) + "\n                ")]) : _c('div', [_vm._v("\n                  Não iniciado.\n                ")])]
      }
    }, {
      key: "processos",
      fn: function(row) {
        return [(row.value.length > 0) ? _c('div', _vm._l((row.value), function(item, index) {
          return _c('div', {
            key: index,
            staticClass: "column all-centered"
          }, [_c('div', {
            staticClass: "prest-item-processo"
          }, [_c('b', [_vm._v("#" + _vm._s(item.fk_processo))]), _vm._v(" " + _vm._s(item.situacao.replace('_', ' ')) + "\n                    ")])])
        }), 0) : _c('div', [_vm._v("\n                  Nenhum Processo encontrado.\n                ")])]
      }
    }, {
      key: "valor_liberado",
      fn: function(row) {
        return [(row.item.valor_liberado) ? _c('div', [_vm._v("\n                  " + _vm._s(_vm._f("real")(row.value)) + "\n                ")]) : _c('div', [_vm._v("\n                  Nenhum Adiantamento encontrado.\n                ")])]
      }
    }, {
      key: "total_gravado",
      fn: function(row) {
        return [(row.item.total_gravado) ? _c('div', [_vm._v("\n                  " + _vm._s(_vm._f("real")(row.value)) + "\n                  ")]) : _c('div', [_vm._v("\n                  -\n                ")])]
      }
    }, {
      key: "ds_nome",
      fn: function(row) {
        return [_c('div', {
          staticClass: "column all-start"
        }, [_c('div', [_c('router-link', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              placement: 'right',
              animation: 'perspective',
              distance: '1',
              size: 'small',
              arrow: true
            }),
            expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'small', arrow : true }"
          }],
          attrs: {
            "title": '<h5>Ir para a página do Projeto</h5>',
            "to": {
              name: 'projeto',
              params: {
                numero: row.item.ds_codigo_projeto_erp
              }
            },
            "target": "_blank"
          }
        }, [_vm._v(" "), _c('i', {
          staticClass: "fa fa-external-link"
        })]), _vm._v(" ["), _c('b', [_vm._v(_vm._s(row.item.id))]), _vm._v("] " + _vm._s(row.value) + "\n                  ")], 1), _vm._v(" "), _c('div', {
          staticClass: "column all-end prest-item-entidade"
        }, [_c('b', [_c('router-link', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              placement: 'right',
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
          }],
          attrs: {
            "title": '<h5>Ir para o Cadastro da entidade</h5>',
            "to": {
              name: 'cadastro-entidade-visualiza',
              params: {
                id: row.item.id_entidade
              }
            },
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-user"
        })]), _vm._v(" " + _vm._s(_vm._f("cnpj")(row.item.ds_cnpj_entidade)))], 1), _vm._v(" "), _c('i', [_vm._v(" " + _vm._s(row.item.ds_nome_entidade))])])])]
      }
    }, {
      key: "status",
      fn: function(row) {
        return [(row.item.data_atualizacao && !row.item.processos) ? _c('div', {
          staticClass: "prest-status-iniciado"
        }, [_c('b', [_vm._v("Cadastro Iniciado")])]) : _vm._e(), _vm._v(" "), (row.item.processos && row.item.data_atualizacao) ? _c('div', {
          staticClass: "prest-status-tarefa"
        }, [_vm._v("\n                  Tarefa de Prestação de Contas\n                ")]) : _vm._e(), _vm._v(" "), (!row.item.data_atualizacao) ? _c('div', {
          staticClass: "prest-status-pendente"
        }, [_c('b', [_vm._v("Pendente Cadastro")])]) : _vm._e()]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(_vm.usuarioLogado.userType === 'ENTIDADE' && row.item.valor_liberado) ? _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editarGED(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editarGED(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Visualizar")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'ENTIDADE' && !row.item.valor_liberado) ? _c('div', [_vm._v("\n                      Sem parcela de Adiantamento.\n                    ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('b-row', {
    staticClass: "row-flex all-end"
  }, [_vm._v("\n                " + _vm._s(_vm.table.totalRows) + " registro(s) encontrado(s).\n              ")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "8",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "prest-box-title row-flex centered-start"
  }, [_vm._v("Prestação de Contas "), _c('i', {
    staticClass: "fa fa-file",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("E-mails "), _c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-da030c9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/prestacaoContasSimplificado/ListaSolicitacaoPrestacaoContasSimplificado.vue
// module id = 2088
// module chunks = 1